<template>
  <div id="subsc" v-html="subscriptionEndsStr"></div>
</template>

<script>
import { nowMoment } from '@/mixins/now-moment'
import declension from '@/modules/declension.js'
import { DATE_FORMAT } from '@/main.config'

export default {
  name: 'SubscriptionInfo',
  components: {},
  mixins: [nowMoment],
  props: {
    dateSubscription: {
      type: String,
      required: false
    },
    isShort: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({}),
  computed: {
    subscriptionEndsStr() {
      if (this.dateSubscription) {
        let momentDate = this.moment(this.dateSubscription)
        if (momentDate.isSameOrBefore(this.moment(this.nowMoment.format('MM/DD/YYYY')), 'day')) {
          if (this.isShort) return '<span class="text-danger">' + this.$t('general.expiredShort') + '</span>'
          else return this.$t('general.expired')
        } else {
          let diffDate = momentDate.diff(this.moment(this.nowMoment.format('MM/DD/YYYY')), 'days')
          if (diffDate < 14) {
            let nDay = `${declension(diffDate, [
              `${this.$tc('unit.day', 0)}`,
              `${this.$tc('unit.day', 1)}`,
              `${this.$tc('unit.day', 2)}`
            ])}`

            if (this.isShort) {
              return (
                '<span class="text-danger">' +
                `${this.$t('general.willExpiredShort')} ${diffDate} ${nDay}` +
                '</span>'
              )
            } else {
              return `${this.$t('general.willExpired')} ${diffDate} ${nDay}`
            }
          } else {
            let dateMoment = this.moment.utc(this.dateSubscription, DATE_FORMAT.serverFull).local()
            let date = dateMoment.format(DATE_FORMAT.ru)
            return '<span class="text-success">' + `До ${date}` + '</span>'
          }
        }
      } else {
        return '<span class="text-success">' + 'Не ограничен' + '</span>'
      }
    }
  }
}
</script>
